
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const STPPreventiveBreakdownMaintainanceExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={5} style={{ textAlign: 'center', fontSize: 16 }}>
                        {name}
                    </th>
                </tr>

                {/* <tr><td></td></tr> */}

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col">Sr No.</th>
                        <th>Equipment</th>
                        <th>Breakdown Date </th>
                        <th>Work Date </th>
                        <th>Work Done </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.equipmentDetails ? item.equipmentDetails : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.breakdownDate ? moment(item.breakdownDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workDoneDate ? moment(item.workDoneDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workRemark ? item.workRemark : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}